// extracted by mini-css-extract-plugin
export default {"container":"InquiryResultPage_container__h4FYX","success":"InquiryResultPage_success__Ge134","sucBtn":"InquiryResultPage_sucBtn__GPksj"};